
@if(data?.avvisi) {
<p-table [value]="data!!.avvisi!!" [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template pTemplate="header">
      <tr>
          <th>Codice Fiscale</th>
          <th>Messaggio</th>
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
      <tr>
          <td>{{ item.codiceFiscale }}</td>
          <td>{{ item.messaggio }}</td>
      </tr>
  </ng-template>
</p-table>
}
